import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

export class FirstDownCommand implements Command {
  constructor(
    private gamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND FirstDownCommand 1/10')
    this.gamePlay.down = 1
    this.gamePlay.distance = 10
  }
}
